import $ from 'jquery';
import Vue from 'vue';
import LangSelect from "./LangSelect";

Vue.component('lang-select', LangSelect);

const lsvm = new LangSelect();
lsvm.$mount();

$('#lang-select').append(lsvm.$el);

